import { LoadingIcon } from "@/app/_lib/components/loading-icon";
import classNames from "classnames";

type PageLoadingProps = {
  fullHeight?: boolean;
};

export const PageLoading = ({ fullHeight = false }: PageLoadingProps) => {
  return (
    <div
      className={classNames(
        "flex justify-center items-center",
        fullHeight ? "h-screen" : "h-[calc(100vh-100px)]"
      )}
    >
      <LoadingIcon className="w-16" />
    </div>
  );
};